const PAGE1_MAINTITLE = "PAGE1_MAINTITLE";
const PAGE1_ADDR = "PAGE1_ADDR";
const PAGE1_TIME = "PAGE1_TIME";
const PAGE1_SUBTITLE = "PAGE1_SUBTITLE";
const page1mainTitleChange = content => ({
  type: PAGE1_MAINTITLE,
  content: content
});
const page1AddrChange = content => ({
  type: PAGE1_ADDR,
  content: content
});
const page1TimeChange = content => ({
  type: PAGE1_TIME,
  content: content
});
const page1SubtitleChange = content => ({
  type: PAGE1_SUBTITLE,
  content: content
});
export {
  PAGE1_MAINTITLE,
  PAGE1_SUBTITLE,
  PAGE1_ADDR,
  PAGE1_TIME,
  page1mainTitleChange,
  page1AddrChange,
  page1TimeChange,
  page1SubtitleChange
};
